import Maybe from 'true-myth/maybe';

import type { OidcProvider } from '../customization/customization-response';
import type { AuthorizationTokenTransformed } from './authorization-token';
import type { AuthorizationReceived } from './cognito';

export type CognitoStateSession = {
    readonly attributes: AuthorizationTokenTransformed;
    readonly expiresInSeconds: number;
    readonly jsonWebToken: string;
};

type CognitoState = {
    readonly callback: Maybe<AuthorizationReceived>;
    readonly oidcProvider: Maybe<OidcProvider>;
    readonly refreshTimeout: Maybe<number>;
    readonly session: Maybe<CognitoStateSession>;
};

type CognitoStateApi = {
    readonly get: <K extends keyof CognitoState>(key: K) => CognitoState[K];
    readonly update: (stateToUpdate: Partial<CognitoState>) => void;
};

export const createCognitoState = (): CognitoStateApi => {
    let cognitoState: CognitoState = {
        callback: Maybe.nothing(),
        oidcProvider: Maybe.nothing(),
        refreshTimeout: Maybe.nothing(),
        session: Maybe.nothing(),
    };

    return {
        get(key) {
            return cognitoState[key];
        },
        update(stateToUpdate) {
            cognitoState = {
                ...cognitoState,
                ...stateToUpdate,
            };
        },
    };
};
